import { render, staticRenderFns } from "./QuoteTemplateLabourTypeModal.vue?vue&type=template&id=165698fa"
import script from "./QuoteTemplateLabourTypeModal.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateLabourTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports